if (!customElements.get('nav-mega-tab-collection')) {

  class NavMegaTabCollection extends HTMLElement {
    constructor() {
      super()
      this.initSide()
    }

    get collectionTitle() {
      return this.querySelector('.nav-mega__tab-collection-top .collection-title')
    }

    get collectionViewAll() {
      return this.querySelector('.nav-mega__tab-collection-top .view-all')
    }

    get activedClickItem() {
      return this.querySelector('.click-item.is-active')
    }

    connectedCallback() {
      // active first item
      setTimeout(() => {
        this.querySelector('.click-item').click()
      }, 500)
    }

    initSide() {
      const subItems = this.querySelectorAll('.side-item[sub-item]')
  
      subItems.forEach(subItem => {
        // 找到父项（前一个非sub-item的details元素）
        let prevSibling = subItem.previousElementSibling
        while (prevSibling && prevSibling.hasAttribute('sub-item')) {
          prevSibling = prevSibling.previousElementSibling
        }
        
        if (prevSibling) {
          prevSibling.setAttribute('has-child', '')
          // 在父项中创建或获取ul容器
          let ul = prevSibling.querySelector('ul');
          if (!ul) {
            ul = document.createElement('ul')
            ul.classList.add('details__content')
            prevSibling.appendChild(ul)
          }
          
          // 提取sub-item的span文本内容
          const spanText = subItem.querySelector('span').textContent
          
          // 创建新的li元素并添加到ul中
          const li = document.createElement('li')
          li.classList.add('click-item')
          li.setAttribute('sub-item', '')
          li.textContent = spanText
          ul.appendChild(li);

          const summery = subItem.querySelector('summary')
          li.setAttribute('data-collection-url', summery.dataset.collectionUrl)
          li.setAttribute('data-title', summery.dataset.title)
          li.setAttribute('data-item-id', summery.dataset.itemId)
          
          // 从DOM中移除原来的sub-item
          subItem.remove()
        }
      });

      this.querySelectorAll('.click-item').forEach(item => {
        item.addEventListener('click', this.onSideClickItemClick.bind(this))
      })
    }

    onSideClickItemClick(e) {
      let clickItem = e.target
      if (!clickItem.hasAttribute('data-item-id')) {
        clickItem = e.target.closest('.click-item[data-item-id]')
      }

      const processActiveItem = item => {
        this.querySelector('.click-item.is-active')?.classList.remove('is-active')
        item.classList.add('is-active')

        this.querySelector('mega-tab-collection-product-list.is-active')?.setVisible(false)
        this.querySelector(`mega-tab-collection-product-list[data-item-id="${item.dataset.itemId}"]`).setVisible(true)
        
        this.collectionTitle.textContent = item.dataset.title
        this.collectionViewAll.setAttribute('href', item.dataset.collectionUrl)
      }

      const details = clickItem.closest('details')
      if (clickItem.tagName == 'SUMMARY' && details?.hasAttribute('has-child')) {
        if (details.hasAttribute('open') && !details.querySelector('.click-item.is-active')) {
          processActiveItem(details.querySelector('ul > .click-item'))
        }
      } else if(!clickItem.classList.contains('is-active')) {
        this.querySelectorAll('details.side-item').forEach(d => {
          if (d != details) {
            d.open = false
          }
        })
        processActiveItem(clickItem)
      }

    }
  }
 
  customElements.define('nav-mega-tab-collection', NavMegaTabCollection)
}




if (!customElements.get('drawer-mega-tab-collection')) {
  class DrawerMegaTabCollection extends HTMLElement {
    constructor() {
      super()
      this.init()
      this.initSubDetails()
    }

    init() {
      this.querySelectorAll('details').forEach(d => {
        d.addEventListener('toggle', this.onDetailsToggle.bind(this))
      })
    }

    initSubDetails() {
      const subItems = this.querySelectorAll('.drawer__menu-group[sub-item]')
  
      subItems.forEach(subItem => {
        // 找到父项（前一个非sub-item的details元素）
        let prevSibling = subItem.previousElementSibling
        while (prevSibling && prevSibling.hasAttribute('sub-item')) {
          prevSibling = prevSibling.previousElementSibling
        }
        
        if (prevSibling) {
          const details = prevSibling.firstElementChild
          details.setAttribute('has-child', '')
          // 在父项中创建或获取ul容器
          let subList = details.querySelector('.sub-details-list');
          if (!subList) {
            subList = document.createElement('div')
            subList.classList.add('sub-details-list')
            details.appendChild(subList)
          }

          const subItemDetails = subItem.querySelector('details')
          subItemDetails.querySelector('summary')?.classList.add('sub-item')
          subList.appendChild(subItemDetails)
          subItem.remove()
        }
      });
    }

    onDetailsToggle(e) {
      if (e.detail) {
        const productList = e.detail.current.querySelector('.collection-products mega-tab-collection-product-list')
        if (productList) {
          productList.setVisible(e.detail.open)
        }
      }
    }
  }
  customElements.define('drawer-mega-tab-collection', DrawerMegaTabCollection)
}



if (!customElements.get('mega-tab-collection-product-list')) {

  class MegaTabCollectionProductList extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    get splideElement() {
      return this.querySelector('.splide')
    }

    get progressBar() {
      return this.querySelector('.product-panel__list-progress span')
    }

    init() {
      if (!this.splideElement) {
        return
      }
      this.splide = new Splide(this.splideElement, {
        arrows: false,
        pagination: false,
        autoWidth: true,
        gap: 24
      })
      this.splide.on('moved', () => {
        this.updateProductProgressBar()
      })
      this.splide.mount()
      // 初始化都先跑到1，方便在setVisible(true)时，go(0)能触发moved事件
      this.splide.go(1)
    }

    setVisible(visible) {
      if (visible) {
        this.classList.add('is-active')
        this.style.opacity = 0
        this.style.transform = 'translateX(100px)'
        Motion.animate(this, { opacity: 1, transform: 'translateX(0px)' })
        this.splide.go(0)
      } else {
        this.classList.remove('is-active')
        // 为了visible=true时，go(0)能触发moved事件
        this.splide.go(2)
      }
    }

    updateProductProgressBar() {
      // 用setTimeout，否则无法正确获取.is-visible
      setTimeout(() => {
        const slideList = Array.from(this.splideElement.querySelectorAll('.splide__slide'))
        let lastVisibleIndex = null
        for (let i = 0; i < slideList.length; i++) {
          if (slideList[i].classList.contains('is-visible')) {
            lastVisibleIndex = i + 1
          }
        }
        if (lastVisibleIndex != null) {
          const barPercent = lastVisibleIndex / slideList.length * 100.0
          this.progressBar.style.width = `${barPercent}%`
        } else {
          bar.style.width = '0%'
        }
      }, 10)
    }
  }

  customElements.define('mega-tab-collection-product-list', MegaTabCollectionProductList);
}